export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";